module.exports = __webpack_public_path__ + "media/images/favicon-d9fde8047bcafa238c54b7cdec28f5db.ico";